import _ from "lodash";
import React from "react";

import classes from "./PostList.scss";
import {
  PLACEHOLDER_RECT_IMAGE,
  PLACEHOLDER_RECT_IMAGE_COUNT,
} from "Constants";
import I18nHOC from "UIComponents/I18nHOC";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import { EmptyState, IconButton } from "@toddle-edu/ds-web";
import { EvidenceIllustration } from "@toddle-edu/ds-theme";
import { ChevronRightOutlined } from "@toddle-edu/ds-icons";

const styles = {
  newImagePlaceholder: {
    borderRadius: "8px 0px 0px 8px",
    height: "72px",
    width: "72px",
    flex: "inherit",
  },
  imagePlaceholder: {
    height: "64px",
    width: "80px",
    flex: "inherit",
  },
  listStyleWithAlert: {
    padding: "16px 0px",
  },
  listStyleWithoutAlert: {
    paddingBottom: "16px ",
  },
};

const emptyStateSubtitleStyle = {
  lineHeight: "24px",
};

const PostList = props => {
  const renderPosts = () => {
    const { onItemClicked, t, feedList, isUserTypeStudent } = props;

    const getGoalsAndStudentCount = post => {
      return {
        goalsCount: _.reduce(
          _.get(post, "elementPYP", []),
          (acc, element) => {
            return acc + _.get(element, "value.length", 0);
          },
          0
        ),
        studentsCount: _.get(post, "students.totalCount", 0),
      };
    };

    const getPostImage = post => {
      let imageUrl = undefined;

      _.forEach(_.get(post, "attachments", []), attachment => {
        if (
          _.includes(
            ["IMAGE", "VIDEO", "WORKBOOK", "FILE"],
            _.get(attachment, "type")
          )
        ) {
          imageUrl = _.get(
            attachment,
            _.get(attachment, "type") === "IMAGE" ? "url" : "thumbUrl"
          );
        }
      });

      return imageUrl;
    };

    return _.get(feedList, "length", 0) > 0 ? (
      _.map(feedList, post => {
        const node = _.get(post, "node", {});
        const leAndStudentCount = getGoalsAndStudentCount(node);
        const title =
          _.size(_.get(node, "title")) > 0
            ? _.get(node, "title")
            : t("common:untitled");
        return (
          <div
            onClick={() => onItemClicked(post)}
            className={classes.singlePostItemContainer}
            key={_.get(node, "id")}
            data-test-id={`journal-postcreation-taglearninggoals-posts-item-${_.get(
              node,
              "id"
            )}`}
          >
            <div className={classes.postAvatar}>
              <ResourceImagePlaceHolder
                id={post?.id}
                imageUrl={
                  getPostImage(node) ||
                  PLACEHOLDER_RECT_IMAGE[
                    _.get(node, "id") % PLACEHOLDER_RECT_IMAGE_COUNT
                  ]
                }
                imageThumbSize={56}
                containerStyle={styles.newImagePlaceholder}
              />
            </div>
            <div className={classes.postDetailsContainer}>
              <div className={classes.postTitle}>{title}</div>
              <div className={classes.resourceCentralIdea}>
                {leAndStudentCount.goalsCount === 0
                  ? null
                  : leAndStudentCount.goalsCount +
                    " " +
                    t(
                      leAndStudentCount.goalsCount === 1
                        ? "common:learning_goal_singular"
                        : "common:learning_goals"
                    )}
                {leAndStudentCount.studentsCount > 0 && !isUserTypeStudent ? (
                  <>
                    {leAndStudentCount.goalsCount ? (
                      <div className={classes.postListDot}></div>
                    ) : null}
                    {leAndStudentCount.studentsCount}{" "}
                    {leAndStudentCount.studentsCount > 1
                      ? t("journal:student_tagged_plural")
                      : t("journal:student_tagged")}
                  </>
                ) : null}
              </div>
            </div>
            <IconButton
              icon={<ChevronRightOutlined size={"x-small"} />}
              variant={"plain"}
              size={"x-small"}
            />
          </div>
        );
      })
    ) : (
      <div className={classes.noDataContainer}>
        <EmptyState
          illustration={EvidenceIllustration}
          size="small"
          title={t("common:empty_instructions_title_text")}
          subtitleStyle={emptyStateSubtitleStyle}
        />
      </div>
    );
  };

  const { showAlert } = props;
  return (
    <div className={classes.listContainer}>
      <div
        className={classes.listContent}
        style={{
          ...(showAlert
            ? styles.listStyleWithAlert
            : styles.listStyleWithoutAlert),
        }}
      >
        {renderPosts()}
      </div>
    </div>
  );
};

export default I18nHOC({ resource: ["common", "journal"] })(PostList);
